export default "__VITE_ASSET__ae744cd9__"